import { createSlice } from '@reduxjs/toolkit';

import { TUser } from '../../types/user';

const initialState: TUser = {
  isAuthenticated: false,
};

/* istanbul ignore next */
const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {},
});

export const { reducer: userReducer } = userSlice;
